export default {
    // api: 'http://192.168.10.249:8089/game/service/',
    // api: 'http://localhost:8080/game/service/'
    api: 'https://www.yingxiongbb.cn/game/service/'
}